module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tip":"Tip"},"cn":{"tip":"提示"}}')
  delete Component.options._Ctor
}
